export const GET_SUGGESTIONS = 'BrilinkGetSuggestions/Success';
export const LOADING_SUGGESTIONS = 'BrilinkGetSuggestions/Loading';
export const GET_LIST_BRILINK = 'BrilinkGetRecommendations/Success';
export const LOADING_LIST_BRILINK = 'BrilinkGetRecommendations/Loading';
export const POST_TINDAK_LANJUT = 'BrilinkPostTindakLanjut/Success';
export const LOADING_TINDAK_LANJUT = 'BrilinkPostTindakLanjut/Loading';
export const GET_DETAIL_BRILINK = 'BrilinkGetDetail/Success';
export const LOADING_DETAIL_BRILINK = 'BrilinkGetDetail/Loading';
export const GET_INFINITE_LIST_BRILINK = 'BrilinkGetInfiniteList/Success';
export const LOADING_INFINITE_LIST_BRILINK = 'BrilinkGetInfiniteList/Loading';
export const GET_PROSES_KUNJUNGAN = 'BrilinkGetProsesKunjungan/Success';
export const LOADING_PROSES_KUNJUNGAN = 'BrilinkGetProsesKunjungan/Loading';
export const GET_PERSENTASE_MINGGUAN = 'BrilinkGetPersentaseMingguan/Success';
export const LOADING_PERSENTASE_MINGGUAN =
  'BrilinkGetPersentaseMingguan/Loading';
export const GET_PERSENTASE_BULANAN = 'BrilinkGetPersentaseBulanan/Success';
export const LOADING_PERSENTASE_BULANAN = 'BrilinkGetPersentaseBulanan/Loading';
export const GET_FILTER_KELURAHAN = 'BrilinkGetFilterKelurahan/Success';
export const LOADING_FILTER_KELURAHAN = 'BrilinkGetFilterKelurahan/Loading';
